import React from 'react';
import './Loading.css';

const Loading = ({ message = 'Loading…', fullScreen = false }) => (
  <div className={`loading ${fullScreen ? 'loading-fullscreen' : ''}`}>
    <div className="loading-mark" aria-hidden="true" />
    <p className="loading-message">{message}</p>
  </div>
);

export default Loading;
